const REFERRAL_STORAGE_KEY = "seller_referrals_by_event";

function readReferralMap() {
  try {
    if (typeof window === "undefined") return {};
    const raw = window.localStorage.getItem(REFERRAL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
}

function writeReferralMap(nextMap) {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(nextMap || {}));
  } catch (_) {}
}

export const getReferralTokenFromSearch = (search = "") => {
  try {
    const params = new URLSearchParams(String(search || ""));
    return String(params.get("r") || "").trim();
  } catch (_) {
    return "";
  }
};

export const clearStoredEventReferral = (eventId) => {
  if (!eventId) return;
  const nextMap = readReferralMap();
  delete nextMap[String(eventId)];
  writeReferralMap(nextMap);
};

export const storeEventReferral = ({
  eventId,
  token,
  code = "",
  expiresAt = null,
  sellerId = null,
}) => {
  if (!eventId || !token) return null;
  const nextMap = readReferralMap();
  const record = {
    eventId: String(eventId),
    token: String(token),
    code: code || "",
    sellerId: sellerId || null,
    expiresAt: expiresAt || null,
    storedAt: new Date().toISOString(),
  };
  nextMap[String(eventId)] = record;
  writeReferralMap(nextMap);
  return record;
};

export const getStoredEventReferral = (eventId) => {
  if (!eventId) return null;
  const record = readReferralMap()[String(eventId)];
  if (!record) return null;
  if (record.expiresAt) {
    const expiresAtMs = new Date(record.expiresAt).getTime();
    if (Number.isFinite(expiresAtMs) && expiresAtMs <= Date.now()) {
      clearStoredEventReferral(eventId);
      return null;
    }
  }
  return record;
};
